import { render, staticRenderFns } from "./FAQsList.vue?vue&type=template&id=23dcdd5b&scoped=true"
import script from "./FAQsList.vue?vue&type=script&lang=js"
export * from "./FAQsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dcdd5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23dcdd5b')) {
      api.createRecord('23dcdd5b', component.options)
    } else {
      api.reload('23dcdd5b', component.options)
    }
    module.hot.accept("./FAQsList.vue?vue&type=template&id=23dcdd5b&scoped=true", function () {
      api.rerender('23dcdd5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/FAQsList.vue"
export default component.exports